import styled from '@emotion/styled';

const INDICATOR_SIZE = 16;
const CURRENT_DOT_SIZE = 8;
const UPCOMING_RING_SIZE = 14;

export const TimelineList = styled('ol')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[16],
  margin: 0,
  padding: 0,
  listStyle: 'none',
}));

export const TimelineRow = styled('li')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  gap: theme.spacing[12],
}));

export const IndicatorSlot = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: INDICATOR_SIZE,
  height: INDICATOR_SIZE,
});

export const CurrentDot = styled('span')(({ theme }) => ({
  width: CURRENT_DOT_SIZE,
  height: CURRENT_DOT_SIZE,
  borderRadius: theme.radius.full,
  backgroundColor: theme.colors.brand.solid,
}));

export const UpcomingRing = styled('span')(({ theme }) => ({
  boxSizing: 'border-box',
  width: UPCOMING_RING_SIZE,
  height: UPCOMING_RING_SIZE,
  borderRadius: theme.radius.full,
  border: `1.5px solid ${theme.colors.border.strong}`,
}));

export const LabelSlot = styled('span')({
  flex: 1,
  minWidth: 0,
});
